// CSS imports
import '../css/style.scss'



// JS imports

// import lazyLoadProjects from './modules/lazyLoadProjects';
// lazyLoadProjects();



// Modules/Classes Imports

// import ChangeFontSize from "./modules/ChangeFontSize"



// Instantiate a new Object using Classes

// var changeFontSize = new ChangeFontSize()



// Functions 

// Fix Transitions Bug on load
window.onload = function () {
    document.querySelector('body').classList.remove('preload');
}

// Smoothscroll js
// var scroll = new SmoothScroll('a[href*="#"]', {
//   speed: 200,
//   offset: 0
// });